const firebaseConfig = {
    apiKey: "AIzaSyAHza7v1LXdqmUSjUPxpSLRHd7aA9KdKrA",
    authDomain: "healthcare-website-decc7.firebaseapp.com",
    projectId: "healthcare-website-decc7",
    storageBucket: "healthcare-website-decc7.appspot.com",
    messagingSenderId: "942220169716",
    appId: "1:942220169716:web:1f04bb6017dbb9e5a5a9a1"
  };
  export default firebaseConfig;